var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellOffFillUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.63 17.0479L13.5825 15.0004H2.25002V14.2504L3.75002 12.7504V8.25035C3.75002 7.39535 3.96752 6.54785 4.37252 5.79035L0.83252 2.25035L1.79252 1.29785L16.5825 16.0954L15.63 17.0479ZM14.25 11.8504V8.25035C14.25 5.92535 12.7275 3.87785 10.5 3.21785V3.00035C10.5 2.60253 10.342 2.221 10.0607 1.93969C9.77938 1.65839 9.39784 1.50035 9.00002 1.50035C8.6022 1.50035 8.22066 1.65839 7.93936 1.93969C7.65806 2.221 7.50002 2.60253 7.50002 3.00035V3.21785C7.04252 3.35285 6.60002 3.55535 6.19502 3.81785L14.25 11.8504ZM9.00002 17.2504C9.39784 17.2504 9.77938 17.0923 10.0607 16.811C10.342 16.5297 10.5 16.1482 10.5 15.7504H7.50002C7.50002 16.1482 7.65806 16.5297 7.93936 16.811C8.22066 17.0923 8.6022 17.2504 9.00002 17.2504Z",
    fill: "#FA8C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOffFillUnmute);
export default __webpack_public_path__ + "static/media/bell-off-fill-unmute.0945010b.svg";
export { ForwardRef as ReactComponent };